import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;
const broadcastDriver = window._app_config_.BROADCAST_DRIVER;
Pusher.logToConsole = true;
let echoConfig = {};

if (broadcastDriver === "pusher") {
    echoConfig = {
        broadcaster: "pusher",
        key: window._app_config_.PUSHER_APP_KEY,
        wsHost: window._app_config_.PUSHER_HOST,
        wsPort: window._app_config_.PUSHER_PORT ?? 80,
        wssPort: window._app_config_.PUSHER_PORT ?? 443,
        forceTLS: (window._app_config_.PUSHER_SCHEME ?? "https") === "https",
        enabledTransports: ["ws", "wss"],
        cluster: window._app_config_.PUSHER_APP_CLUSTER, // Add this line
        // logToConsole: true,
    };
} else if (broadcastDriver === "reverb") {
    echoConfig = {
        broadcaster: "reverb",
        key: window._app_config_.REVERB_APP_KEY,
        wsHost: window._app_config_.REVERB_HOST,
        wsPort: window._app_config_.REVERB_PORT ?? 80,
        wssPort: window._app_config_.REVERB_PORT ?? 443,
        forceTLS: (window._app_config_.REVERB_SCHEME ?? "https") === "https",
        enabledTransports: ["ws", "wss"],
        // 👇 Enable logging
        logToConsole: false,
    };
} else if (broadcastDriver === "ably") {
    echoConfig = {
        broadcaster: "ably",
        key: window._app_config_.ABLY_KEY,
    };
} else if (broadcastDriver === "redis") {
    echoConfig = {
        broadcaster: "redis",
        key: window._app_config_.REDIS_KEY,
        wsHost: window._app_config_.REDIS_HOST,
        wsPort: window._app_config_.REDIS_PORT ?? 80,
        wssPort: window._app_config_.REDIS_PORT ?? 443,
        forceTLS: (window._app_config_.REDIS_SCHEME ?? "https") === "https",
        enabledTransports: ["ws", "wss"],
    };
} else {
    echoConfig = {
        broadcaster: "null",
    };
}
window.Echo = new Echo(echoConfig);